// Client for the layer's booking + inbox API (backend/ext/bookingApi.js,
// backend/ext/mailInbox.js). Same base as every other backend surface: the
// instance's runtime env.js UPLOAD_API ('' = same-origin behind Caddy / the
// CRA dev proxy). Owner calls carry the kit session token — the owner is the
// instance operator signed in through the kit login.
import { kitEnv } from '../../data/kitEnv';
import { getIdToken } from '../../data/authPlane';

const API = kitEnv('UPLOAD_API', process.env.REACT_APP_UPLOAD_API || '').replace(/\/$/, '');

async function parse(res) {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || `request failed (${res.status})`);
  return body;
}

async function authHeaders() {
  const token = await getIdToken().catch(() => null);
  if (!token) throw new Error('sign in required');
  return { Authorization: `Bearer ${token}` };
}

const get = (path) => fetch(`${API}${path}`).then(parse);
const post = (path, payload, headers = {}) => fetch(`${API}${path}`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', ...headers },
  body: JSON.stringify(payload),
}).then(parse);

export const getCatalog = () => get('/ext/booking/catalog');
export const getDays = (month) => get(`/ext/booking/days?month=${month}`);
export const getAvailability = (date) => get(`/ext/booking/availability?date=${date}`);
export const createBooking = (payload) => post('/ext/booking/create', payload);

// ---- Owner surface (kit session with the internal claim) ---------------------
export const adminBookings = async () =>
  fetch(`${API}/ext/booking/admin/bookings`, { headers: await authHeaders() }).then(parse);

export const adminSetStatus = async (id, status) =>
  post('/ext/booking/admin/status', { id, status }, await authHeaders());

// ---- Mail inbox (SES receiving → S3, read through the layer API) -------------
const authedGet = async (path) => fetch(`${API}${path}`, { headers: await authHeaders() }).then(parse);

export const adminMailList = () => authedGet('/ext/mail/admin/messages');
export const adminMailRead = (key) => authedGet(`/ext/mail/admin/message?key=${encodeURIComponent(key)}`);
export const adminMailDelete = async (key) =>
  fetch(`${API}/ext/mail/admin/message?key=${encodeURIComponent(key)}`, { method: 'DELETE', headers: await authHeaders() }).then(parse);
